import {useLocation} from 'react-router';
import {useDispatch} from 'react-redux';
import {useEffect, useRef} from 'react';

import {SET_PREVIOUS_ROUTE} from '@actions/actionTypes';

export const usePreviousRoute = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const prevPathRef = useRef(null);

    useEffect(() => {
        const current = location.pathname;

        if (prevPathRef.current) {
            dispatch({ type: SET_PREVIOUS_ROUTE, payload: prevPathRef.current });
        }
        prevPathRef.current = current;
    }, [location.pathname]);
};
